
export const initialState={
  values: {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    address: '',
    state: '',
    postalCode: '',
    town: '',
    note: '',
  },
  errors: {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    address: '',
    state: '',
    postalCode: '',
    town: '',
    note: '',
  },
}
